<app-skelitions [hidden]="!spinner" [value]="2" class="mb-2"></app-skelitions>

<section [hidden]="spinner">
  <div class="container">
    <div class="container-fluid p-0">
      <div class="container max-width-1400">
        <div class="mob-web-flexx">
          <div>
            <h1 [hidden]="this.tab == 'New Branch'" class="big-head">
              {{ "Most active Branches and centers" | translator }}
            </h1>
          </div>
          <div class="d-flex">
            <div dir="ltr" class="mx-2 d-inline-block">
              <p-calendar
                class="v4-calander"
                placeholder="{{ 'date' | translator }}"
                selectionMode="range"
                [readonlyInput]="true"
                [(ngModel)]="dateFilter"
                (ngModelChange)="onDateRangeChange()"
              />
            </div>
            <div class="v4-rotate">
              <i
                pTooltip="{{ 'Reset' | translator }}"
                tooltipPosition="top"
                class="fa-solid fa-arrows-rotate mx-3"
                (click)="resetFilter()"
              ></i>
            </div>
          </div>
        </div>
        <div [hidden]="this.tab == 'New Branch'" class="">
          <!-- <h6 class="min-head">هذا هو نص باللغة العربية. يمكنك كتابة هنا</h6> -->
          <div
            class="d-flex m-1 flex-wrap justify-content-center align-items-end"
          >
            <div *ngIf="usersDate?.topThree[1]?._id" class="hover-effects">
              <div
                class="d-flex justify-content-center align-items-center mt-5"
              >
                <img
                  class="result-icone"
                  src="../../../../../assets/Header-picture.png"
                  alt="loading"
                />
              </div>
              <div class="position-box pos-rel blue-border">
                <div class="pos-num">2</div>
                <div class="mr-custom">
                  <h3 class="pos-big">{{ usersDate?.topThree[1]?._id }}</h3>
                  <h6 class="pos-min">
                    {{ usersDate?.topThree[1]?.courses?.length }}
                    {{ "number of workshops" | translator }}
                  </h6>
                </div>
              </div>
            </div>
            <div *ngIf="usersDate?.topThree[0]?._id" class="hover-effects">
              <div
                class="d-flex justify-content-center align-items-center mt-4"
              >
                <img
                  class="result-icone"
                  src="../../../../../assets/Header-picture.png"
                  alt="loading"
                />
              </div>
              <div class="position-box pos-rel blue-border height-150">
                <div class="pos-num">1</div>
                <div class="mr-custom">
                  <h3 class="pos-big">{{ usersDate?.topThree[0]?._id }}</h3>
                  <h6 class="pos-min">
                    {{ usersDate?.topThree[0]?.courses?.length }}
                    {{ "number of workshops" | translator }}
                  </h6>
                </div>
              </div>
            </div>
            <div *ngIf="usersDate?.topThree[2]?._id" class="hover-effects">
              <div
                class="d-flex justify-content-center align-items-center mt-5"
              >
                <img
                  class="result-icone"
                  src="../../../../../assets/Header-picture.png"
                  alt="loading"
                />
              </div>
              <div class="position-box pos-rel blue-border">
                <div class="pos-num-3">3</div>
                <div class="ml-custom">
                  <h3 class="pos-big">{{ usersDate?.topThree[2]?._id }}</h3>
                  <h6 class="pos-min">
                    {{ usersDate?.topThree[2]?.courses?.length }}
                    {{ "number of workshops" | translator }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-md-12 col-12">
            <div>
              <h1 class="main-big-head">
                {{
                  this.fixedTypes.includes(this.tab)
                    ? ("Training Workshops" | translator)
                    : ("training course" | translator)
                }}
              </h1>
            </div>

            <div class="d-flex flex-wrap mob-flex">
              <div
                *ngFor="let branch of usersDate?.userData"
                [hidden]="usersDate?.length <= 0"
                class="column-view"
              >
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <img
                    class="result-icone-2"
                    src="../../../../../assets/icons/SBC/selected-course-2.svg"
                    alt="loading"
                  /> -->

                  <img
                    *ngIf="checkisImg(branch?.ou?.image); else elseBlock"
                    src="{{ staticURL }}{{ branch?.ou?.image }}"
                    class="result-icone-2"
                    style="
                      height: 30px;
                      width: 30px;
                      background: white;
                      border-radius: 6px;
                      margin-left: 5px;
                    "
                  />
                  <ng-template #elseBlock>
                    <i class="top-bg" class="{{ branch?.ou?.image }} p-2"></i>
                  </ng-template>
                </div>
                <div class="result-heading">
                  <div>{{ branch?.ou?.name }} ({{ branch?.ou?.location }})</div>
                </div>
                <div class="result">
                  <div>
                    <i class="result-icone pi pi-fw pi-user icone-v4"></i>
                  </div>
                  <div class="result-num">
                    {{ branch.numberOfAttendees }}
                  </div>
                </div>
                <div class="result">
                  <div>
                    <img
                      class="result-icone"
                      src="../../../../../assets/v-4-icone/Layer-1.png"
                      alt="loading"
                    />
                  </div>
                  <div class="result-num">
                    {{ branch.trainings }}
                  </div>
                </div>
              </div>

              <app-no-data *ngIf="usersDate?.length <= 0"></app-no-data>
            </div>
          </div>
          <div class="col-md-6 col-12 custom-flex">
            <div class="">
              <h1 class="big-head mt-5">
                {{
                  this.fixedTypes.includes(this.tab)
                    ? ("Most highlighted workshops" | translator)
                    : ("Most highlighted Traninig" | translator)
                }}
              </h1>
              <!-- <h6 class="min-head">هذا هو نص باللغة العربية. يمكنك كتابة هنا</h6> -->
              <div class="d-flex flex-wrap justify-content-center">
                <div
                  class="left-box-width"
                  *ngFor="let topTopics of usersDate?.topTopics"
                >
                  <div class="left-box-border">
                    <img
                      *ngIf="
                        checkisImg(topTopics?.ou?.image_sq);
                        else elseBlock
                      "
                      src="{{ staticURL }}{{ topTopics?.ou?.image }}"
                      class="width-120"
                    />
                    <ng-template #elseBlock>
                      <i
                        class="{{ topTopics?.ou?.image }} p-2"
                        class="width-120"
                        style="font-size: 1rem"
                      ></i>
                    </ng-template>
                  </div>
                  <div class="img-box-text-color">
                    <h6 class="img-text-box">{{ topTopics?._id }}</h6>
                  </div>
                </div>
                <!-- <div class="left-box-width">
                                <div class="left-box-border">
                                    <img class="width-120" src="../../../../../assets/Ministry-of-Health.png" alt="loading">
                                </div>
                                <div class="img-box-text-color">
                                    <h6 class="img-text-box">مرحبًا بك في صفحتي
                                        هذا هو نص باللغة العربية. يمكنك كتابة هنا</h6>
                                </div>
                            </div>
                            <div class="left-box-width">
                                <div class="left-box-border">
                                    <img class="width-120" src="../../../../../assets/nelcLogo2020.png" alt="loading">
                                </div>
                                <div class="img-box-text-color">
                                    <h6 class="img-text-box">مرحبًا بك في صفحتي
                                        هذا هو نص باللغة العربية. يمكنك كتابة هنا</h6>
                                </div>
                            </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer mt-5 footer-bg-color pos-rel">
        <div class="footer-abs">
          <img
            class="footer-img"
            src="../../../../../assets/Header-picture.png"
            alt="loading"
          />
        </div>
        <div class="row mt-5">
          <div class="col-md-12 col-12 col-border-right">
            <h6 class="color-h6">
              {{
                this.fixedTypes.includes(this.tab)
                  ? ("workshops total and completed" | translator)
                  : ("training total and completd" | translator)
              }}
            </h6>
            <div class="footer-flex mt-3">
              <div class="d-flex align-items-center m-2">
                <h6 class="color-h6">
                  {{
                    this.fixedTypes.includes(this.tab)
                      ? ("Completed Workshops" | translator)
                      : ("Total number of completed trainings" | translator)
                  }}
                </h6>
                <div class="border-num">
                  {{
                    usersDate?.totalAndCompleted[0]?.COMPLETED
                      ? usersDate?.totalAndCompleted[0]?.COMPLETED
                      : ("There is no data" | translator)
                  }}
                </div>
              </div>
              <div class="d-flex align-items-center m-2">
                <h6 class="color-h6">
                  {{
                    this.fixedTypes.includes(this.tab)
                      ? ("Total Number of workshops" | translator)
                      : ("Total number of trainings" | translator)
                  }}
                </h6>
                <div class="border-num">
                  {{
                    usersDate?.totalAndCompleted[0]?.TOTAL
                      ? usersDate?.totalAndCompleted[0]?.TOTAL
                      : ("There is no data" | translator)
                  }}
                </div>
              </div>
              <!-- dummy work start -->
              <div class="d-flex align-items-center m-2">
                <h6 class="color-h6">
                  {{ "Total Attendees" | translator }}
                </h6>
                <div class="border-num">
                  {{
                    usersDate?.totalAndCompleted[0]?.ATTENDEES
                      ? usersDate?.totalAndCompleted[0]?.ATTENDEES
                      : ("There is no data" | translator)
                  }}
                </div>
              </div>
              <!-- dummy work end -->
            </div>
          </div>
          <div class="col-md-7"></div>
        </div>
      </div>
    </div>
    <!--  -->

    <label *ngIf="progressDetails?.length > 0" class="dashboard-label my-3">{{
      "training request completion" | translator
    }}</label>

    <div *ngIf="progressDetails?.length > 0" class="qbl-card">
      <div class="row px-2">
        <div class="col-md-6 px-3" *ngFor="let ministry of progressDetails">
          <div class="row progress-box d-flex align-items-center my-1">
            <div class="col-7 d-flex align-items-center p-0">
              <span>
                <img
                  *ngIf="checkisImg(ministry?.ou?.image_sq); else elseBlock"
                  src="{{ staticURL }}{{ ministry?.ou?.image_sq }}"
                  class="progress-img"
                />
                <ng-template #elseBlock>
                  <i
                    class="{{ ministry?.ou?.image_sq }} p-2"
                    style="font-size: 1rem"
                  ></i>
                </ng-template>
              </span>
              <span class="">
                {{ ministry?.ou?.name }} ({{ ministry?.location?.name }})
              </span>
            </div>
            <div class="col-5 p-0">
              <div class="">
                <p-progressBar class="v4-progress" [value]="ministry?.percent">
                  <ng-template pTemplate="content" let-value>
                    <span>{{ value }}/{{ ministry?.total_records }}</span>
                  </ng-template>
                </p-progressBar>
                {{ ministry.completed }}/{{ ministry?.total_records }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart> -->
    </div>
  </div>

  <div *ngIf="piCharts?.length > 0" class="container">
    <label class="dashboard-label my-3">{{
      "Branch Details" | translator
    }}</label>

    <div class="row mb-5">
      <div *ngFor="let item of piCharts" class="col-12 col-md-4">
        <div class="qbl-card">
          <div class="d-flex justify-content-between bg-ms">
            <div>
              <p class="mb-0 card-text-clr">
                {{ item?.chatData.datasets[0].label }}
              </p>
            </div>
            <div>
              <span class="card-text-clr"
                ><b
                  >{{
                    (
                      (item.data.completed / item.data.total_records) *
                      100
                    ).toFixed(2)
                  }}%</b
                ></span
              >
              &nbsp;

              <span class="card-text-clr">{{
                "Completion Rate" | translator
              }}</span>
            </div>
          </div>
          <p-chart
            type="pie"
            [data]="item?.chatData"
            [options]="piChartOptions"
          ></p-chart>
        </div>
      </div>
    </div>
  </div>

  <app-skilltrainingdash
    *ngIf="usersDate?.skillTrainingData?.[0]"
    [data]="usersDate?.skillTrainingData?.[0]"
  ></app-skilltrainingdash>
</section>

<!-- <app-footer></app-footer> -->
